export default __webpack_public_path__ + "static/media/advisory-notification-icon.561dd538.png";